import { render, staticRenderFns } from "./_ModulesPermissionForm.vue?vue&type=template&id=21ac2cac&scoped=true&"
import script from "./_ModulesPermissionForm.vue?vue&type=script&lang=js&"
export * from "./_ModulesPermissionForm.vue?vue&type=script&lang=js&"
import style0 from "./_ModulesPermissionForm.vue?vue&type=style&index=0&id=21ac2cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac2cac",
  null
  
)

export default component.exports